const TestAnimation = () => {
    return ( 
        <div>
            Test Animation
        </div>
     );
}

export default TestAnimation;